import React from 'react';
import RootRoutes from './routes';
import Footer from './components/Footer';

const App = () => (
    <React.Fragment>
        <RootRoutes />
        <Footer />
    </React.Fragment>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx